<template>
     <v-dialog v-model="dialog" max-width="500px" scrollable>
            <v-card class="add-dialog">
                <v-card-title class="dialog-title">
                    <v-icon class="dialog-icon">mdi-plus-circle</v-icon>
                    <span>Edit Commission</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" class="commision-form">
                        <v-text-field
                            v-model="newCommission.commissionName"
                            label="Commission Name"
                            outlined
                            :rules="[v => !!v || 'Name is required']"
                            required
                            class="mb-4"
                        />
                        <!-- <v-text-field
                            v-model="newCommission.commission_percentage"
                            label="Percentage"
                            type="number"
                            outlined
                            suffix="%"
                            :rules="[
                                v => !!v || 'Percentage is required', 
                                v => v > 0 || 'Must be greater than 0',
                                v => v <= 100 || 'Must be less than or equal to 100'
                            ]"
                            required
                            class="mb-4"
                        /> -->
                        <v-select
                            v-model="newCommission.status"
                            :items="['Active', 'Inactive']"
                            label="Status"
                            outlined
                            :rules="[v => !!v || 'Status is required']"
                            required
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="dialog-actions">
                    <v-spacer />
                    <v-btn text @click="onClose">Cancel</v-btn>
                    <v-btn class="add-btn" @click="editCommission">Edit Commission</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default({
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function
    },
    editItem: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      showAddDialog: this.dialog,
      newCommission: {
        commissionName: '',
        commission_percentage: null,
        status: 'Active'
      },
      valid: false
    };
  },
  watch: {
    // Watch for changes to editItem and dialog open
    dialog(val) {
      if (val && this.editItem) {

        this.newCommission = {
          commissionName: this.editItem.commissionName || '',
          status: this.editItem.status || 'Active'
        };
      }
      if (!val) {
        this.resetForm();
      }
    },
    // If editItem changes while dialog is open
    editItem: {
      handler(newVal) {
        if (this.dialog && newVal) {
          this.newCommission = {
            commissionName: newVal.commissionName || '',
            commission_percentage: newVal.commission_percentage ?? null,
            status: newVal.status || 'Active'
          };
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions({
        editCommissionAction: 'commission/editCommission'
    }),
    async editCommission() {
      const form = this.$refs.form;
      // Validate the form before submitting
      const isValid = await (form && form.validate ? form.validate() : this.valid);
      if (!isValid) return;

      // Defensive: include an id if needed for update
      const payload = {
          ...this.editItem, 
        commissionId:this.editItem._id,
        commissionName: this.newCommission.commissionName,
        status: this.newCommission.status
      };
      this.editCommissionAction(payload)
        .then(() => {
          this.resetForm();
          this.onClose && this.onClose();
        })
        .catch(error => {
          console.error('Error editing commission:', error);
        });
    },
    resetForm() {
      this.newCommission = {
        commissionName: '',
        commission_percentage: null,
        status: ''
      };
      this.valid = false;
    }
  },
})
</script>

<style scoped>
        
/* Dialog Styles */
.add-dialog {
  border-radius: 12px;
}

.dialog-title {
  background: linear-gradient(135deg,#084468,#3b7ca1);
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding: 16px;
}

.dialog-icon {
  color: white;
}

.dialog-actions {
  padding: 8px 16px 16px;
}

.add-btn{
    background: linear-gradient(135deg,#084468,#3b7ca1);
  color: white;
}


.commision-form{
    margin-top: 12px;
}
</style>